import type {CSSObject} from '@mui/material/styles';
import {COLORS} from '../../colors-ts';

const formControlShades = {
    Default: COLORS.mithraBlue,
    Primary: COLORS.primary,
    Secondary: COLORS.secondary,
    Success: COLORS.success,
    Error: COLORS.error,
    Info: COLORS.mithraBlue,
    Warning: COLORS.warning,
} as const;

type FormControlComponentClass = 'MuiCheckbox' | 'MuiRadio' | 'MuiSwitch';
type FormControlColorName = keyof typeof formControlShades;

export const formControlColorStates = (
    componentClass: FormControlComponentClass,
    colorOverrides?: Partial<Record<FormControlColorName, CSSObject>>,
): CSSObject =>
    Object.fromEntries(
        Object.entries(formControlShades).map(([color, shades]) => [
            `&.${componentClass}-color${color}`,
            {
                borderRadius: '50%',
                '&:hover': {
                    backgroundColor: shades[100],
                },
                '&:active': {
                    backgroundColor: shades[300],
                },
                ...colorOverrides?.[color as FormControlColorName],
            },
        ]),
    );
